import React, { useEffect, useState } from "react";
import Modal from "../../Common/Modal";
import "./AutomaticBackupSettingModal.css";
import { AutomaticBackupSetting } from "../../../Model/Backup";
import SwitchButton from "../../Buttons/SwitchButton";
import SpinnerTextBox from "../../Controls/SpinnerTextBox";

type Props = {
  automaticbackupSetting: AutomaticBackupSetting;
  showPopUp: boolean;
  setShowPopUp: (show: boolean) => void;
  onSaveAction: (automaticBackupSetting: AutomaticBackupSetting) => void;
  onSetAutomaticBackupSetting: (
    automaticBackupSetting: AutomaticBackupSetting
  ) => void;
};

export default function AutomaticBackupSettingModal({
  automaticbackupSetting,
  showPopUp,
  setShowPopUp,
  onSaveAction,
  onSetAutomaticBackupSetting,
}: Props) {
  const [initialAutomaticbackupSetting, setInitialAutomaticbackupSetting] =
    useState(automaticbackupSetting);
  const [isIntervalError, setIsIntervalError] = useState(false);

  useEffect(() => {
    if (showPopUp) {
      setInitialAutomaticbackupSetting(automaticbackupSetting);
    }
  }, [showPopUp == true]);

  const onClickOk = () => {
    setShowPopUp(false);
    onSaveAction(automaticbackupSetting);
  };

  const onClickCancel = () => {
    setShowPopUp(false);
  };
  return (
    <Modal show={showPopUp} onHide={onClickCancel} className={""}>
      <Modal.Header
        hideButtonEnabled={false}
        title="Backup Configuration"
        className="automatic-backup-setting-modal-header"
      ></Modal.Header>
      <Modal.Body className="automatic-backup-setting-body">
        <div className="line-backup-setting-3-colum">
          <div className="label">
            <span>Backup Interval</span>
          </div>
          <div className="content">
            <SpinnerTextBox
              className="increment-decrement-backup-interval"
              value={automaticbackupSetting.backupIntervalInDays}
              onValueChanged={(value) =>
                onSetAutomaticBackupSetting({
                  ...automaticbackupSetting,
                  backupIntervalInDays: +value as number,
                })
              }
              style={{
                textAlign: "end",
              }}
              min={1}
              max={360}
              onErrorOccured={() => {setIsIntervalError(true)}}
              onErrorCleared={() => {setIsIntervalError(false)}}
            />
          </div>
          <div className="unit">
            <span>days</span>
          </div>
        </div>
        <div className="line-backup-setting-2-colum">
          <div className="label">
            <span>Email Backup Notification</span>
          </div>
          <div className="unit">
            <SwitchButton
              withLetter={true}
              isOn={automaticbackupSetting.emailBackupNotification}
              onToggle={(value) =>
                onSetAutomaticBackupSetting({
                  ...automaticbackupSetting,
                  emailBackupNotification: value as boolean,
                })
              }
            />
          </div>
        </div>
        <div className="line-backup-setting-2-colum">
          <div className="label">
            <span>Last Backup Date</span>
          </div>
          <div className="unit">
            <span>
              {automaticbackupSetting.lastBackupDate.toLocaleDateString()}{" "}
              {automaticbackupSetting.lastBackupDate.toLocaleTimeString()}
            </span>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer
        onClickOk={onClickOk}
        onClickCancel={onClickCancel}
        okLabel="Save"
        okButtonDisabled={Object.is(
          automaticbackupSetting,
          initialAutomaticbackupSetting
        ) || isIntervalError}
      />
    </Modal>
  );
}
